import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/edit-icon.svg'


const _hoisted_1 = { class: "review-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Patient Information", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_4 = { class: "review-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Insurance Information", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_7 = { class: "review-table" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "Vision Plan Administrator:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "Are you the primary account holder:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "Vision Plan Name:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, "Vision Plan Type:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "Vision Plan Group Number:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", null, "Member ID or Account Number:", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", null, "Employer/Company Name", -1)
const _hoisted_15 = { class: "review-header" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", null, "Claim Information", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_18 = { class: "review-table" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "vision-item-title" }
const _hoisted_21 = { class: "vision-item" }
const _hoisted_22 = { class: "vision-item-table" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", null, "Service Date:", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", null, "Cost:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_26 = { class: "review-header" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h2", null, "Merchant Information", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  class: "edit-icon",
  src: _imports_0,
  alt: "edit icon"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_30 = { class: "review-table" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", null, "Merchant Name:", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", null, "Address:", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", null, "City:", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", null, "State:", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", null, "Zip:", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("th", null, "Phone Number:", -1)

import { computed } from "vue";
import VisionVariables from "@/types/VisionVariables";
import VisionFormSteps from "@/types/VisionFormSteps";
import VisionClaimItems from "@/types/VisionClaimItems";
import FormTitle from "../common/FormTItle.vue";
import ReviewPatientInfo from "../common/ReviewPatientInfo.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  props: {
    modelValue: {},
    variables: {},
    claimItems: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const currentStep = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(FormTitle, {
            title: "Review (1/2)",
            description: "Please review this information for accuracy before continuing."
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "card-container" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_v_spacer),
                _createElementVNode("img", {
                  class: "edit-icon",
                  src: _imports_0,
                  alt: "edit icon",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (currentStep.value = _unref(VisionFormSteps).PersonalInformation))
                }),
                _createVNode(_component_v_btn, {
                  class: "edit-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (currentStep.value = _unref(VisionFormSteps).PersonalInformation))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Update information ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_3,
              _createVNode(ReviewPatientInfo, { variables: _ctx.variables }, null, 8, ["variables"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, { class: "card-container" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_v_spacer),
                _createElementVNode("img", {
                  class: "edit-icon",
                  src: _imports_0,
                  alt: "edit icon",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (currentStep.value = _unref(VisionFormSteps).InsuranceInformation))
                }),
                _createVNode(_component_v_btn, {
                  class: "edit-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (currentStep.value = _unref(VisionFormSteps).InsuranceInformation))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Update information ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_6,
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.planAdministrator), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_9,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.isAccountHolder ? "Yes" : "No"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.visionPlanName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.visionPlanType), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.visionPlanGroupNumber), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_13,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.memberId), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_14,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.employerOrCompanyName), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, { class: "card-container" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_v_spacer),
                _createElementVNode("img", {
                  class: "edit-icon",
                  src: _imports_0,
                  alt: "edit icon",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (currentStep.value = _unref(VisionFormSteps).ClaimInformation))
                }),
                _createVNode(_component_v_btn, {
                  class: "edit-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (currentStep.value = _unref(VisionFormSteps).ClaimInformation))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Update information ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_17,
              _createElementVNode("table", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claimItems, (info, title) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-4",
                    key: title
                  }, [
                    (_ctx.variables[title])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("h3", _hoisted_20, _toDisplayString(title), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info, (item, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "mb-2",
                              key: i
                            }, [
                              _createElementVNode("h3", _hoisted_21, "Item " + _toDisplayString(i + 1), 1),
                              _createElementVNode("table", _hoisted_22, [
                                _createElementVNode("tr", null, [
                                  _hoisted_23,
                                  _createElementVNode("td", null, _toDisplayString(item.date), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _hoisted_24,
                                  _createElementVNode("td", null, "$" + _toDisplayString(item?.amount?.toFixed(2)), 1)
                                ])
                              ])
                            ]))
                          }), 128)),
                          _hoisted_25
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, { class: "card-container" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_v_spacer),
                _hoisted_28
              ]),
              _hoisted_29,
              _createElementVNode("table", _hoisted_30, [
                _createElementVNode("tr", null, [
                  _hoisted_31,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.providerName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_32,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.providerAddressStreet), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_33,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.providerAddressCity), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_34,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.providerAddressState), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_35,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.providerAddressZip), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_36,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.providerPhoneNumber), 1)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})